import { graphql } from '@/generated/gql';

export const NEGOTIATION_LIST_UPDATE_RESPONSIBLE_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiationListUpdateResponsible($id: UUID!, $data: TsrctDemandResponsibleUsersInput!) {
    tesseract {
      demand(id: $id) {
        responsibleUsers {
          update(data: $data) {
            id
            responsibleUserIds
          }
        }
      }
    }
  }
`);
